module.exports = __webpack_public_path__ + "img/xift-logo.1864b63c.svg";